export default "__VITE_ASSET__a21ed682__"